var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.953,
    height: 16.953,
    viewBox: "0 0 16.953 16.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropright-circle",
    "data-name": "Icon ionic-ios-arrow-dropright-circle",
    d: "M3.375,11.852a8.477,8.477,0,1,0,8.477-8.477A8.475,8.475,0,0,0,3.375,11.852Zm9.964,0L10,8.547a.787.787,0,0,1,1.113-1.113L15,11.334a.786.786,0,0,1,.024,1.084L11.2,16.261a.785.785,0,1,1-1.113-1.108Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightCircle);
export default __webpack_public_path__ + "static/media/icon-arrow-right-circle.6198d70b45bf00284bbe7c3a0b12d81b.svg";
export { ForwardRef as ReactComponent };